export const ROUTE_PATH = {
     PAGE_NOT_FOUND: '404',
     FORBIDDEN: '403',
     HOME: 'home',
     BATHING_SCHEDULE: 'bathing-schedule',
     EXCRETION_MONITOR: 'excreation',
     BATHE_MANAGEMENT: 'bathe-management',
     USER_DASHBOARD: 'user-dashboard',
     TITLE_SETTINGS: 'title-settings',
     TV_NO_OFFICE: 'tv/auth/no-office',
     TV_USER_SETTINGS: 'tv/user-settings-tv',  
     TV_BATHING_SCHEDULE: 'tv/bathing-schedule',
     TV_EXCRETION_MONITOR: 'tv/excreation',
     TV_USER_DASHBOARD: 'tv/user-dashboard-tv',
     TV_USER_DASHBOARD_DETAIL: 'tv/user-dashboard-detail',
     TV_TITLE_SETTINGS: 'tv/title-settings',
     TV_MENU_SHOW: 'tv/menu-show',
     TV_MENU_SHOW_YB: 'tv/menu-show-yb',
     TV_STARTUP: 'tv/startup',
     TV_BLANK: 'tv/blank',
     TV_SHORT_TIME: 'tv/short-time',
     TV_FUNCTIONAL_TRAINING: 'tv/functional-training',

     CUST_LOGIN: 'cust-login',
     LOGIN: 'auth',

     CHECK_SHEET: 'check-sheet',
     CHECK_SHEET_NYUSHO: 'check-sheet/nyusho',
     CHECK_SHEET_TSUSHO: 'check-sheet/tsusho',
     CHECK_SHEET_SHORT_TIME: 'check-sheet/short-time',
     CHECK_SHEET_FUNCTIONAL_TRAINING: 'check-sheet/functional-training',
     TV_CHECK_SHEET: 'tv/check-sheet',
     TV_CHECK_SHEET_NYUSHO: 'tv/check-sheet/nyusho',
     TV_CHECK_SHEET_TSUSHO: 'tv/check-sheet/tsusho',
     TV_CHECK_SHEET_SHORT_TIME: 'tv/check-sheet/short-time',
     TV_CHECK_SHEET_FUNCTIONAL_TRAINING: 'tv/check-sheet/functional-training',
     
     CORP_SELECTION: 'corp-selection',
     OFFICE_SELECTION: 'office-selection',
     TV_OFFICE_SELECTION: 'office-selection-tv',
}
